// Menu.js
import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../contexts/UserContext";
import "./Menu.css";

const Menu = ({ role_id }) => {
  const { token } = useContext(UserContext);
  const navigate = useNavigate();

  // Inicializamos el estado de expansión del submenu en false siempre
  const [showSubmenu, setShowSubmenu] = useState(false);

  // Opcional: Si aún se quiere guardar el estado manualmente, se podría actualizar, pero no leerlo en el valor inicial.
  useEffect(() => {
    // Esto garantiza que, al cargar la página, el submenu se colapse independientemente de sessionStorage.
    setShowSubmenu(false);
  }, []);

  let menuOptions = [];

  // Para roles 1 y 2 (SuperAdmin y Administrador)
  if ([1, 2].includes(role_id)) {
    menuOptions = [
      { label: "Ventas", action: "/dashboard?page=Ventas" },
      { label: "Ingresar venta", action: "/ingresar-venta" },
      { label: "Contratos Digitales", action: "/contratos" },
      { label: "Modificación de plan", action: "/modificacion-de-plan" },
      { label: "Dar de baja", action: "/dar-de-baja" },
      { label: "Documentos Firmados", action: "/document-status" },
      { label: "Mi perfil", action: "/dashboard?page=Mi perfil" },
      {
        label: "Gestión de administración",
        submenu: [
          {
            label: "Registrar usuario",
            action: "/dashboard?page=Registrar usuario",
          },
          { label: "Usuarios", action: "/dashboard?page=Usuarios" },
          {
            label: "Tabla promociones por zona",
            action: "/dashboard?page=Datos",
          },
          { label: "Comunas", action: "/dashboard?page=Comunas" },
          {
            label: "Promociones y Montos de instalación",
            action: "/dashboard?page=Tarifas",
          },
          { label: "Empresas", action: "/dashboard?page=Empresas" },
          {
            label: "Canales de venta",
            action: "/dashboard?page=Canales de venta",
          },
          { label: "Motivos", action: "/dashboard?page=Motivos" },
          { label: "Firmantes", action: "/dashboard?page=Firmantes" }, // Movido al submenu como fue solicitado
        ],
      },
      { label: "Cerrar sesión", action: "logout" },
    ];
  }
  // Menú específico para rol 4 (Validador)
  else if (role_id === 4) {
    menuOptions = [
      { label: "Ventas", action: "/dashboard?page=Ventas" },
      { label: "Ingresar venta", action: "/ingresar-venta" },
      { label: "Contratos Digitales", action: "/contratos" },
      { label: "Modificación de plan", action: "/modificacion-de-plan" },
      { label: "Dar de baja", action: "/dar-de-baja" },
      { label: "Documentos Firmados", action: "/document-status" },
      { label: "Mi perfil", action: "/dashboard?page=Mi perfil" },
      { label: "Cerrar sesión", action: "logout" },
    ];
  }
  // Para otros roles se mantienen las opciones originales (rol 3, 5, 6)
  else {
    menuOptions = [
      { label: "Ventas", action: "/dashboard?page=Ventas" },
      { label: "Ingresar venta", action: "/ingresar-venta" },
      { label: "Mi perfil", action: "/dashboard?page=Mi perfil" },
      {
        label: "Gestión de administración",
        submenu: [
          {
            label: "Registrar usuario",
            action: "/dashboard?page=Registrar usuario",
          },
          { label: "Usuarios", action: "/dashboard?page=Usuarios" },
          {
            label: "Tabla promociones por zona",
            action: "/dashboard?page=Datos",
          },
          { label: "Comunas", action: "/dashboard?page=Comunas" },
          {
            label: "Promociones y Montos de instalación",
            action: "/dashboard?page=Tarifas",
          },
          { label: "Empresas", action: "/dashboard?page=Empresas" },
          {
            label: "Canales de venta",
            action: "/dashboard?page=Canales de venta",
          },
          { label: "Motivos", action: "/dashboard?page=Motivos" },
        ],
      },
      { label: "Cerrar sesión", action: "logout" },
    ];
  }

  // Función unificada para gestionar la navegación o el logout
  const handleClick = (action) => {
    if (action === "logout") {
      handleLogout();
    } else {
      navigate(action);
    }
  };

  return (
    <ul className="menu-sidebar">
      <h1>Menú</h1>
      <hr />
      <br />
      {menuOptions.map((option, index) => (
        <li key={index}>
          <button
            onClick={() => {
              if (option.submenu) {
                setShowSubmenu((prev) => !prev);
              } else {
                handleClick(option.action);
              }
            }}
          >
            {option.label}
            {option.submenu && (
              <span className={`arrow ${showSubmenu ? "up" : "down"}`} />
            )}
          </button>
          {option.submenu && showSubmenu && (
            <ul>
              {option.submenu.map((submenuOption, submenuIndex) => (
                <li key={submenuIndex}>
                  <button onClick={() => handleClick(submenuOption.action)}>
                    {submenuOption.label}
                  </button>
                </li>
              ))}
            </ul>
          )}
          <hr />
        </li>
      ))}
    </ul>
  );

  async function handleLogout() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/logout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        console.clear();
        localStorage.removeItem("token");
        sessionStorage.removeItem("token");
        document.cookie.split(";").forEach((c) => {
          document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
        navigate("/");
      } else {
        console.error("Error al cerrar sesión");
      }
    } catch (error) {
      console.error("Error al intentar cerrar sesión:", error);
    }
  }
};

export default Menu;
